import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LayoutDashboardIcon, InboxIcon, BuildingIcon, ClipboardCheckIcon, FileTextIcon, ShieldCheckIcon, TagIcon, FileSignatureIcon, ShoppingCartIcon, TruckIcon, TrendingUpIcon, ClipboardListIcon, ReceiptIcon, CreditCardIcon, MessageSquareIcon, HelpCircleIcon, SettingsIcon, UsersIcon, ListChecksIcon, ShieldAlertIcon, ActivityIcon, PackageIcon } from 'lucide-react';
import { Badge } from '../ui/Badge';
export const SideNav: React.FC = () => {
  const {
    role
  } = useAuth();
  const supplierNav = [{
    label: 'Home',
    href: '/supplier/dashboard',
    icon: LayoutDashboardIcon
  }, {
    label: 'Task Inbox',
    href: '/supplier/tasks',
    icon: InboxIcon,
    badge: 9
  }, {
    type: 'divider'
  }, {
    label: 'Company Profile',
    href: '/supplier/profile',
    icon: BuildingIcon
  }, {
    label: 'Onboarding',
    href: '/supplier/onboarding',
    icon: ClipboardCheckIcon
  }, {
    label: 'Documents',
    href: '/supplier/documents',
    icon: FileTextIcon
  }, {
    label: 'Risk & Compliance',
    href: '/supplier/compliance',
    icon: ShieldCheckIcon
  }, {
    type: 'divider'
  }, {
    label: 'Sourcing Events',
    href: '/supplier/sourcing',
    icon: TagIcon
  }, {
    label: 'Contracts',
    href: '/supplier/contracts',
    icon: FileSignatureIcon
  }, {
    type: 'divider'
  }, {
    label: 'Orders',
    href: '/supplier/orders',
    icon: ShoppingCartIcon,
    badge: 2
  }, {
    label: 'Shipments',
    href: '/supplier/shipments',
    icon: TruckIcon
  }, {
    label: 'Forecast',
    href: '/supplier/forecast',
    icon: TrendingUpIcon
  }, {
    label: 'Quality',
    href: '/supplier/quality',
    icon: ClipboardListIcon
  }, {
    type: 'divider'
  }, {
    label: 'Invoices',
    href: '/supplier/invoices',
    icon: ReceiptIcon,
    badge: 1
  }, {
    label: 'Payments',
    href: '/supplier/payments',
    icon: CreditCardIcon
  }, {
    type: 'divider'
  }, {
    label: 'Messages',
    href: '/supplier/messages',
    icon: MessageSquareIcon,
    badge: 1
  }, {
    label: 'Help & Support',
    href: '/supplier/help',
    icon: HelpCircleIcon
  }, {
    label: 'Settings',
    href: '/supplier/settings',
    icon: SettingsIcon
  }];
  const internalNav = [{
    label: 'Home',
    href: '/internal/dashboard',
    icon: LayoutDashboardIcon
  }, {
    type: 'divider'
  }, {
    label: 'Supplier 360',
    href: '/internal/suppliers',
    icon: UsersIcon
  }, {
    label: 'Onboarding Center',
    href: '/internal/onboarding',
    icon: ClipboardCheckIcon,
    badge: 5
  }, {
    label: 'Review Queues',
    href: '/internal/queues',
    icon: ListChecksIcon,
    badge: 12
  }, {
    type: 'divider'
  }, {
    label: 'Risk Workbench',
    href: '/internal/risk',
    icon: ShieldAlertIcon
  }, {
    label: 'Contract Console',
    href: '/internal/contracts',
    icon: FileSignatureIcon
  }, {
    type: 'divider'
  }, {
    label: 'Transaction Monitor',
    href: '/internal/transactions',
    icon: ActivityIcon
  }, {
    label: 'Supply Collab',
    href: '/internal/supply',
    icon: PackageIcon
  }, {
    label: 'Quality Console',
    href: '/internal/quality',
    icon: ClipboardListIcon
  }, {
    type: 'divider'
  }, {
    label: 'Cases & Messages',
    href: '/internal/cases',
    icon: MessageSquareIcon
  }, {
    label: 'Admin & Config',
    href: '/internal/admin',
    icon: SettingsIcon
  }];
  const navItems = role === 'internal' ? internalNav : supplierNav;
  return <aside className="w-60 bg-surface-primary border-r border-border-light h-[calc(100vh-3.5rem)] overflow-y-auto flex-shrink-0 hidden md:block" data-id="element-111">
      <nav className="p-3 space-y-1" data-id="element-112">
        {navItems.map((item, index) => {
        if (item.type === 'divider') {
          return <div key={`div-${index}`} className="h-px bg-border-light my-2 mx-2" data-id="element-113" />;
        }
        const Icon = item.icon as React.ElementType;
        return <NavLink key={item.href} to={item.href as string} className={({
          isActive
        }) => `
                flex items-center justify-between px-3 py-2 rounded-fluent text-sm font-medium transition-colors
                ${isActive ? 'bg-fpg-navy text-white' : 'text-text-secondary hover:bg-surface-secondary hover:text-text-primary'}
              `} data-id="element-114">
              {({
            isActive
          }) => <>
                  <div className="flex items-center gap-3" data-id="element-115">
                    <Icon className={`w-5 h-5 ${isActive ? 'text-white' : 'text-text-tertiary'}`} data-id="element-116" />
                    {item.label}
                  </div>
                  {item.badge && <Badge variant={isActive ? 'neutral' : 'default'} className={isActive ? 'bg-white/20 text-white border-none' : ''} data-id="element-117">
                      {item.badge}
                    </Badge>}
                </>}
            </NavLink>;
      })}
      </nav>
    </aside>;
};